import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImpersonationBarConfig } from './impersonation-bar.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'impersonation-bar',
  templateUrl: './impersonation-bar.component.html',
  styleUrls: ['./impersonation-bar.component.scss'],
})
export class ImpersonationBarComponent implements OnInit {
  @Input() condition;
  @Input() context;
  @Input() config: ImpersonationBarConfig;

  @Output() endImpersonation = new EventEmitter();

  ngOnInit(): void {
    const [context, config] = checkInputsForText([this.context, this.config]);

    this.context = context;
    this.config = config as ImpersonationBarConfig;
  }

  onEndImpersonationClick() {
    this.endImpersonation.emit();
  }
}
